/* eslint-disable max-len */
import React, { Component } from 'react';

import './Sidebar.css';
import Item from './Item';
import Header from './Header';
import UserPanel from './UserPanel';
import Searchbar from './Searchbar';

//un componente que accede a un estado de redux, debe recibirlo com prop
class Sidebar extends Component {
  static defaultProps = {
    children: null,
    toggle: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
    };
    this.onSearchValueChange = this.onSearchValueChange.bind(this);
  }

  onSearchValueChange(e) {
    const { target: { value } } = e;
    this.setState({ searchValue: value });
  }

  widgetReference = null;
  
  render() {
    

    return (
      <aside className="main-sidebar">
        <section className="sidebar">
          <ul className="sidebar-menu" data-widget="tree" >
            { this.props.children }
          </ul>
        </section>
      </aside>
    );
  }
}

export default Sidebar;
export {
  Item, Sidebar as Core, Header, UserPanel, Searchbar,
};
